import React, { useState, useEffect, useRef } from "react";
import { Dialog, DialogContent, DialogActions, Button, IconButton, Tabs, Tab  } from "@mui/material";
import { MapContainer, TileLayer, Polyline, Popup, useMap, Marker } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from 'leaflet';
//import { UpdateStatusCable } from "../UpdateData/UpdateStatusComponent";
import { Snackbar } from '@mui/material';
import CustomSnackbar from "../Optics/Components/CustomSnackbar";
//import { GET_FASTENING_ERRORS_CABLE_API_URL, GET_FASTENING_ERRORS_CABLE_ID_API_URL, GET_FASTENING_ERRORS_COUPLING_ID_API_URL, GET_FASTENING_ERRORS_FOB_ID_API_URL, GET_FASTENING_ERRORS_PON_BOX_ID_API_URL, UPDATE_FASTENING_ERRORS_CABLE_API_URL, UPDATE_FASTENING_ERRORS_COUPLING_API_URL, UPDATE_FASTENING_ERRORS_FOB_API_URL, UPDATE_FASTENING_ERRORS_POB_BOX_API_URL } from "../OpticApiConfig";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import MarkerClusterGroup from 'react-leaflet-cluster';
import { loadCableUpdatingImagesFromServer, uploadCableUpdatingImage } from "./ServiceUtilitiesCableUpdatingFoto";
import ModalCableFotoDetail from "./ModalCableFotoDetail";

const CustomMarker = ({ point, handleSelectPoint, serverImageUrls }) => {
  // Проверяем наличие совпадения по houseId и entrance
  const isMatched = serverImageUrls.some(
    img =>
      img.houseId === point.hid && String(img.entrance) === String(point.entrance)
  );

  const icon = L.divIcon({
    html: `<div style="
      background-color: ${isMatched ? 'lightgreen' : 'rgb(189, 189, 189)'};
      color: ${isMatched ? 'black' : 'black'};
      border-radius: 50%;
      width: 18px;
      height: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 13px;
      border: 2px solid ${isMatched ? 'green' : '#616161'};
      box-shadow: 0 0 3px rgba(0,0,0,0.5);
      ">
      ${point.entrance}
    </div>`,
    iconSize: [30, 30],
    className: ''
  });

  return (
    <Marker position={[point.latitude, point.longitude]} icon={icon}>
      <Popup className="custom-popupUpTer">
        <div style={{ fontSize: '13px' }}>
          <strong>Адрес:</strong> {point.street}, д. {point.house} <br />
          <strong>Подъезд:</strong> {point.entrance}
          <hr />
          <button
            className="buttonIsSaveDialog2"
            onClick={() => handleSelectPoint(point)}
            style={{ fontSize: '12px', padding: '4px 8px', cursor: 'pointer', color: 'black' }}
          >
            Выбрать
          </button>
        </div>
      </Popup>
    </Marker>
  );
};

// const CustomMarker = ({ point, handleSelectPoint  }) => {
 
//   const icon = L.divIcon({
//     html: `<div style="
//     background-color:rgb(189, 189, 189);
//     color: black;
//     border-radius: 50%;
//     width: 18px;
//     height: 18px;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     font-size: 13px;
//     border: 2px solid #616161;
//     box-shadow: 0 0 3px rgba(0,0,0,0.5);
//     ">${point.entrance}</div>`,
//     iconSize: [30, 30],
//     className: ''
//   });
//   return (
//     <Marker position={[point.latitude, point.longitude]} icon={icon}>
        
//       <Popup  className="custom-popupUpTer">
//         <div style={{ fontSize: '13px' }}>
//           <strong>Адрес:</strong> {point.street}, д. {point.house} <br />
//           <strong>Подъезд:</strong> {point.entrance}
//           <hr/>
//           <button className="buttonIsSaveDialog2"
//           onClick={() => {
//             handleSelectPoint(point);
//           }}
//         style={{ fontSize: '12px', padding: '4px 8px', cursor: 'pointer', color:'black' }}
//       >
//         Выбрать
//       </button>
//         </div>
//       </Popup>
      
//     </Marker>
//   );
// };

const ModalUpdatingOptic = ({ open, onClose, context, houses, user }) => {

  const fileInputRef = useRef(null);
  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
  const [mapCenter, setMapCenter] = useState(context.coordinates[0]); 
  const [mapZoom, setMapZoom] = useState(18);

  const [selectedStreet, setSelectedStreet] = useState('');
  const [selectedEntrance, setSelectedEntrance] = useState('');
  const [selectedHid, setSelectedHid] = useState('');
  const [selectedNumberHouse, setSelectedNumberHouse] = useState('');
  const [fileName, setFileName] = useState('');
  const [isFileUploaded, setIsFileUploaded] = useState(false);
  const [serverImageUrls, setServerImageUrls] = useState([]);
  const [uploadMessage, setUploadMessage] = useState('');
  const [openVewingModal,  setOpenVewingModal] = useState(false); 

  useEffect(() => {
    loadCableUpdatingImagesFromServer(context.highwayLineId, setServerImageUrls, setUploadMessage)
  }, []); 

  const handleSelectPoint = (point) => {
    setSelectedStreet(point.street);
    setSelectedEntrance(point.entrance);
    setSelectedHid(point.hid);
    setSelectedNumberHouse(point.house);
  };

  // Обработка выбора файла
  const handleButtonClick = () => {
    fileInputRef.current.click();
  };


  // Обработка загрузки файла
   const handleFileChange = async (event) => {
      const files = Array.from(event.target.files);
       if (files.length > 10) {
          showSnackbar("Максимум 10 фото за раз", "snackbarWarning");
          return;
        }
      if (files.length > 0) {
        await uploadCableUpdatingImage(files, context.highwayLineId, setFileName, setIsFileUploaded, setServerImageUrls, setUploadMessage, selectedHid, selectedEntrance, user.user, showSnackbar);
        setSelectedStreet('');
        setSelectedEntrance('');
        setSelectedHid('');
        setSelectedNumberHouse('');
      }
    };
    // const handleFileChange = async (event) => {
    //   const file = event.target.files[0];
    //   if (file) {
    //     await uploadCableUpdatingImage(file, context.highwayLineId, setFileName, setIsFileUploaded, setServerImageUrls, setUploadMessage, selectedHid, selectedEntrance, user.user, showSnackbar);
    //     setSelectedStreet('');
    //     setSelectedEntrance('');
    //     setSelectedHid('');
    //     setSelectedNumberHouse('');
    //   }
    // };

    const handleModalDetailFoto = () => {
        setOpenVewingModal(true);    
    };


  const handleClose = () => {
   setSelectedStreet('');
   setSelectedEntrance('');
   setSelectedHid('');
   setSelectedNumberHouse('');
   setFileName('');
   setIsFileUploaded(false);
   setServerImageUrls([]);
   setUploadMessage('');
   setMapCenter([0, 0]);
   setMapZoom(13);
   onClose();   
  };

 
  const MapUpdater = () => {
    const map = useMap();
    map.setView(mapCenter, mapZoom);
    return null;
  };

  return (
    <Dialog open={open} className="modalStyle" fullWidth maxWidth={false}>
      <DialogContent>   
          <>
             <div style={{ display: "flex" }}>
              <div className="divBodyModalUpdating" >
            
                <label style={{color: 'black', fontWeight:'bold'}}>ID: <span style={{color:'#d4d4d4', fontWeight:'normal', textShadow: '2px 2px 4px #242424'}}>{context.highwayLineId}</span></label><br/>
                <label style={{color: 'black', fontWeight:'bold'}}>Территория:<span style={{color:'#d4d4d4', fontWeight:'normal', textShadow: '2px 2px 4px #242424'}}> {context.matchingRows[0].canton} / {context.matchingRows[0].region} / {context.matchingRows[0].area}</span></label><br/>
                <label style={{color: 'black', fontWeight:'bold'}}>Марка: <span style={{color:'#d4d4d4', fontWeight:'normal', textShadow: '2px 2px 4px #242424'}}>{context.matchingRows[0].cableName}</span></label><br/>
                <label style={{color: 'black', fontWeight:'bold'}}>Тип: <span style={{color:'#d4d4d4', fontWeight:'normal', textShadow: '2px 2px 4px #242424'}}>{context.matchingRows[0].cableType}</span></label><br/>
                <label style={{color: 'black', fontWeight:'bold'}}>Длина: <span style={{color:'#d4d4d4', fontWeight:'normal', textShadow: '2px 2px 4px #242424'}}>{context.matchingRows[0].lengthCable} м.</span></label><br/>
                <label style={{color: 'black', fontWeight:'bold'}}>Создал: <span style={{color:'#d4d4d4', fontWeight:'normal', textShadow: '2px 2px 4px #242424'}}>{context.matchingRows[0].authorId}</span></label><br/>
                <label style={{color: 'black', fontWeight:'bold'}}>Коммент: <span style={{color:'#d4d4d4', fontWeight:'normal', textShadow: '2px 2px 4px #242424'}}>
                  {context?.matchingRows?.[0]?.description &&
                    context.matchingRows[0].description.match(/.{1,50}/g).map((line, index) => (
                      <div key={index}>{line}</div>
                    ))}
                    </span>
                </label>

                <hr className="horizontalLineModal" />
            
                {serverImageUrls.length != 0 && (
                    <>
                      <button onClick={handleModalDetailFoto} className='buttonFotoDetail' style={{textShadow: '2px 2px 4px #242424'}}>
                            Просмотр файлов
                            <span  className={`countCircle ${serverImageUrls.length > 0 ? 'green' : 'red'}`}>
                                {serverImageUrls.length > 0 ? serverImageUrls.length : 'нет'}
                              </span>
                        </button>   

                        <hr className="horizontalLineModal" />
                      </>
                    )}


                {selectedStreet && selectedEntrance && selectedHid && selectedNumberHouse  && (
                   <div className="divBodyModalUpdating2">
                <label style={{color: '#bdbdbd', fontWeight:'bold', textShadow: '2px 2px 4px #242424'}} >Закрепить фото</label><br/>
               
                <hr className="horizontalLineModal" />
                <label style={{color: 'black', fontWeight:'bold'}}>Адрес:<span style={{color:'#d4d4d4', fontWeight:'normal', textShadow: '2px 2px 4px #242424'}}>
                  {selectedStreet.match(/.{1,50}/g).map((line, index) => (
                      <div key={index}>{line}</div>
                    ))}
                    </span>
                </label><br/>
                <label style={{color: 'black', fontWeight:'bold'}}>Дом: <span style={{color:'#d4d4d4', fontWeight:'normal', textShadow: '2px 2px 4px #242424'}}>{selectedNumberHouse}</span></label><br />
                <label style={{color: 'black', fontWeight:'bold'}}>Подъезд:<span style={{color:'#d4d4d4', fontWeight:'normal', textShadow: '2px 2px 4px #242424'}}>{selectedEntrance}</span></label><br />
                <hr className="horizontalLineModal" />
                <button
                         className="buttonIsSaveDialog2"
                         onClick={handleButtonClick}
                       >
                         Загрузить фото
                       </button> 
                       {/* <input
                          type="file"
                          ref={fileInputRef}
                          style={{ display: 'none' }}
                          onChange={handleFileChange}
                          accept="image/*"
                        /> */}
                        <input
                          type="file"
                          ref={fileInputRef}
                          style={{ display: 'none' }}
                          onChange={handleFileChange}
                          accept="image/*"
                          multiple
                        />
                                  </div>
                                  
                  )}
             </div>
           
 
               <div style={{ flex: 1, height: '70vh', marginLeft: "20px" }}>
                 <MapContainer center={mapCenter} zoom={mapZoom} style={{ height: "100%", width: "100%" , borderRadius: "20px",  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.8)"}}>
                   <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" 
                    maxZoom={19.5} 
                    />
                   <MapUpdater /> 
                      {/* Маркеры для домов */}
                      <MarkerClusterGroup disableClusteringAtZoom={18}>
                        {houses
                          .filter(h => h.latitude && h.longitude)
                          .map((point, index) => (
                            <CustomMarker key={index} point={point}  handleSelectPoint={handleSelectPoint} serverImageUrls={serverImageUrls}/>
                          ))}
                      </MarkerClusterGroup>

                   {context.coordinates.length > 0 && context.matchingRows?.length > 0 && (
                    <Polyline
                      key={JSON.stringify(context.coordinates)}
                      positions={context.coordinates}
                      color={context.matchingRows[0].cableColor || "black"}
                      weight={context.matchingRows[0].cableWidth || 5}
                      dashArray={context.matchingRows[0].cableKind !== 'solid ' ? '5,10' : null}
                    >
                      <Popup autoClose={false} className="custom-popup">
                        <label style={{ fontSize: '13px' }}>
                          <span style={{ color: '#000000', fontWeight: 'bold' }}>ID: </span>
                          <span style={{ color: '#363636' }}>{context.matchingRows[0].highwayLineId}</span>
                        </label>
                        <br />
                        <label style={{ fontSize: '13px' }}>
                          <span style={{ color: '#000000', fontWeight: 'bold' }}>Кабель: </span>
                          <span style={{ color: '#363636' }}>{context.matchingRows[0].cableName}</span>
                        </label>
                        <br />
                        <label style={{ fontSize: '13px' }}>
                          <span style={{ color: '#000000', fontWeight: 'bold' }}>Комментарий: </span>
                          <span style={{ color: '#363636' }}>{context.matchingRows[0].description}</span>
                        </label>
                      </Popup>
                    </Polyline>
                  )}
                </MapContainer>
               </div>
             </div>
             </>
          </DialogContent>

          <DialogActions>
            <Button class="buttonIsHideModal" onClick={handleClose}>
              Закрыть
            </Button>
          </DialogActions>

          <ModalCableFotoDetail
           open={openVewingModal} 
           onClose={() => setOpenVewingModal(false)}
           serverImageUrls={serverImageUrls}
           setServerImageUrls={setServerImageUrls}
           setUploadMessage={setUploadMessage}
           cableId={context.highwayLineId}
           user={user.user}
          />

          {/* Snackbar */}
                <Snackbar
                    anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                    }}
                    open={snackbarOpen}
                    autoHideDuration={6000}
                    onClose={handleCloseSnackbar}
                    message={snackbarMessage}
                    ContentProps={{
                      style: {
                        color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
                      }
                    }}
                  />
    </Dialog>
  );
};

export default ModalUpdatingOptic;